function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MetadataActions, MetadataSelectors, MetadataConstants, MetadataHelpers } from 'invision-core';
import localeKeys from '../../../../locales/keys';
import { IssueWriteOff } from '../../../../reducers/actions/issue.write.off.actions';
import { TransactionErrorSelector, IsFetchingDataSelector } from '../../../../reducers/selectors/customer.transactions.selectors';
import { clearTransactionsError } from '../../../../reducers/actions/customer.transactions.actions';
import { FLOAT } from '../../../shared/constants/regex.constants';
var WriteOffPopupController = /*#__PURE__*/function () {
  function WriteOffPopupController($ngRedux) {
    _classCallCheck(this, WriteOffPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      localeKeys: localeKeys,
      currencyRegex: FLOAT
    });
  }
  return _createClass(WriteOffPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          hasLoadedWriteOffReasons: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.WriteOffReason)(store),
          isLoadingData: IsFetchingDataSelector(store),
          hasLoadedCurrency: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.Currency)(store),
          currency: MetadataSelectors.codes.MetadataCodeTypeDictionarySelector(MetadataConstants.codes.Currency)(store),
          hasLoadedCurrencyPrecision: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CurrencyPrecision)(store),
          currencyPrecision: MetadataSelectors.codes.MetadataCodeTypeDictionarySelector(MetadataConstants.codes.CurrencyPrecision)(store),
          reasons: MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.WriteOffReason)(store),
          transactionError: TransactionErrorSelector(store)
        };
      };
      var controllerActions = {
        clearTransactionsError: clearTransactionsError,
        issueWriteOff: IssueWriteOff,
        fetchCodeTypesThunk: MetadataActions.codes.fetchCodeTypesThunk
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.hasLoadedWriteOffReasons) {
        this.actions.fetchCodeTypesThunk(MetadataConstants.codes.WriteOffReason).then(function () {
          _this.reasonCodes = MetadataHelpers.codes.selectOptionsForCodeValues(_this.state.reasons.items);
        });
      } else {
        this.reasonCodes = MetadataHelpers.codes.selectOptionsForCodeValues(this.state.reasons.items);
      }
      if (!this.state.hasLoadedCurrency) {
        this.actions.fetchCodeTypesThunk(MetadataConstants.codes.Currency).then(function () {
          _this.reasonCodes = MetadataHelpers.codes.selectOptionsForCodeValues(_this.state.reasons.items);
        });
      } else {
        this.reasonCodes = MetadataHelpers.codes.selectOptionsForCodeValues(this.state.reasons.items);
      }
      if (!this.state.hasLoadedCurrencyPrecision) {
        this.actions.fetchCodeTypesThunk(MetadataConstants.codes.CurrencyPrecision).then(function () {
          _this.reasonCodes = MetadataHelpers.codes.selectOptionsForCodeValues(_this.state.reasons.items);
        });
      } else {
        this.reasonCodes = MetadataHelpers.codes.selectOptionsForCodeValues(this.state.reasons.items);
      }
      this.reason = null;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearTransactionsError();
      this.disconnectRedux();
    }
  }, {
    key: "getCurrencyPrecision",
    value: function getCurrencyPrecision() {
      var _this$state,
        _this2 = this,
        _currencyPrecision,
        _currencyPrecision$Ad;
      var currencyPrecision;
      currencyPrecision = Object.values(((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.currencyPrecision) || {}).find(function (data) {
        var _data$AdditionalPrope;
        return (data === null || data === void 0 ? void 0 : (_data$AdditionalPrope = data.AdditionalProperties) === null || _data$AdditionalPrope === void 0 ? void 0 : _data$AdditionalPrope.currency) === _this2.purchaseOrder.Currency;
      });
      if (!currencyPrecision) {
        currencyPrecision = this.state.currency[this.purchaseOrder.Currency];
      }
      if (_typeof(currencyPrecision) === 'object' && (_currencyPrecision = currencyPrecision) !== null && _currencyPrecision !== void 0 && (_currencyPrecision$Ad = _currencyPrecision.AdditionalProperties) !== null && _currencyPrecision$Ad !== void 0 && _currencyPrecision$Ad.decimal_places) {
        return Number(currencyPrecision.AdditionalProperties.decimal_places);
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this3 = this;
      if (this.form.$valid && this.isAmountValid) {
        this.actions.issueWriteOff({
          Amount: this.amount,
          Description: this.description,
          PurchaseOrderId: this.purchaseOrder.Id,
          ReasonCode: this.reason
        }).then(function () {
          _this3.onSubmitSuccess()();
        });
      }
    }
  }, {
    key: "isAmountValid",
    get: function get() {
      var value = parseFloat(this.amount);
      return value > 0 && value <= this.purchaseOrder.Totals.TotalAmount;
    }
  }, {
    key: "amountNgClass",
    get: function get() {
      var _this$form, _this$form$amount, _this$form2, _this$form3, _this$form3$amount;
      return {
        'is-error': (((_this$form = this.form) === null || _this$form === void 0 ? void 0 : (_this$form$amount = _this$form.amount) === null || _this$form$amount === void 0 ? void 0 : _this$form$amount.$touched) || ((_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : _this$form2.$submitted)) && (((_this$form3 = this.form) === null || _this$form3 === void 0 ? void 0 : (_this$form3$amount = _this$form3.amount) === null || _this$form3$amount === void 0 ? void 0 : _this$form3$amount.$invalid) || !(this !== null && this !== void 0 && this.isAmountValid))
      };
    }
  }]);
}();
export default {
  template: require('./write.off.popup.html'),
  controller: WriteOffPopupController,
  controllerAs: 'WriteOff',
  bindings: {
    onClose: '&',
    onSubmitSuccess: '&',
    purchaseOrder: '<'
  }
};